const getDate = (input) => {
  const originalDate = input.split(' ');
  const date = new Date(originalDate[0])
  const month = date.getMonth()
  const day = date.getDate()
  const year = date.getFullYear()
  const dateNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

  const fullDate = dateNames[month] + ' ' + day + ', ' + year
  // console.log(dateNames[month])
  return fullDate
}

export default getDate